import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShield2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconShield2"><Path fillRule="evenodd" clipRule="evenodd" d="M11.3165 1.72529C11.7533 1.53998 12.2467 1.53998 12.6835 1.72529L19.9335 4.80104C20.5801 5.07536 21 5.70968 21 6.41206V13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13V6.41206C3 5.70968 3.41994 5.07536 4.06654 4.80104L11.3165 1.72529Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShield2;
